import Add from '@mui/icons-material/Add'
import { Stack, Typography, IconButton, Tooltip } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import { ProjectCategory as ProjectCategoryT } from '@/types/projects'
import ProjectCard, {
  ProjectForCard,
} from '@/components/project-card/ProjectCard'
import AddProjectMenu from '../add-project-menu/AddProjectMenu'
import ProjectCategoryNameWithActions from './ProjectCategoryNameWithActions'

export type ProjectCategoryProps = {
  canAddEdit: boolean
  category: ProjectCategoryT & { projects: ProjectForCard[] }
  projectsCount?: Record<string, number>
}

export default function ProjectCategory({
  canAddEdit,
  category,
  projectsCount,
}: ProjectCategoryProps) {
  const { projects = [] } = category
  const addProjectOverlay = useOverlay()

  return (
    <Stack spacing={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <ProjectCategoryNameWithActions
          category={category}
          canEdit={canAddEdit}
        />
        {canAddEdit && (
          <>
            <Tooltip title="New Project">
              <IconButton size="small" onClick={addProjectOverlay.open}>
                <Add fontSize="large" color="primary" />
              </IconButton>
            </Tooltip>
            <AddProjectMenu overlay={addProjectOverlay} category={category} />
          </>
        )}
      </Stack>

      {/* Negative margin offsets Grid's surrounding margin */}
      {projects.map((project: ProjectForCard) => {
        if (!canAddEdit && project.setup_state !== 'complete') return
        return (
          <div key={project.id}>
            <ProjectCard
              project={project}
              inProgressCount={projectsCount?.[project.id] || 0}
            />
          </div>
        )
      })}

      {projects.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {canAddEdit ? (
            <i>Create a project to begin processing documents.</i>
          ) : (
            <i>No projects.</i>
          )}
        </Typography>
      )}
    </Stack>
  )
}
